import React, { ReactElement } from 'react';
import { IIconBaseProps } from '../../common/interfaces';
import { IGapSizeProps, IGutterProps, useColumnGapCss, useGutterCss } from '../../fundamentals/spaces/space';
import { useTestId } from '../../hooks/useTestId/useTestId';
import styled from 'styled-components';
import { BaseDiv } from '../../common/BaseElements';
import { IBorderRadiusProps, usePanelBorderRadiusCss } from '../../fundamentals/sizes/borderRadius';
import { Icon } from '../../components/Icon/Icon';
import { Size } from '../../fundamentals/sizes/sizes';

export interface IEmptyCardProps extends IIconBaseProps {
  body: ReactElement;
  iconSize: Size;
}

const encodeBorderImage = (colourHex: string, borderRadius: string) =>
  `url("data:image/svg+xml,<svg width='100%' height='100%' xmlns='http://www.w3.org/2000/svg'><rect width='100%' height='100%' ry='${borderRadius}' rx='${borderRadius}' fill='none' stroke='${encodeURIComponent(colourHex)}' stroke-width='1' stroke-dasharray='8,8' stroke-linecap='square'></rect></svg>")`;

const CardContainer = styled(BaseDiv)<IBorderRadiusProps>`
  ${usePanelBorderRadiusCss()};
  height: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: ${({ theme }) => encodeBorderImage(theme.colours.eoraCoreColours.BORDER_COLOR.COLOR_BORDER_DEFAULT, theme.brandBorderRadius.panel)};
`;

const CardBody = styled(BaseDiv)<IGutterProps & IGapSizeProps>`
  ${useGutterCss()};
  ${useColumnGapCss()};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const EmptyCard: React.FC<IEmptyCardProps> = ({ icon, iconSize, iconType = 'outline', body, ...rest }) => {
  const { generateTestId } = useTestId(rest, 'EmptyCard');

  return (
    <CardContainer {...generateTestId()} {...rest}>
      <CardBody gutter {...generateTestId('Body')}>
        {icon && <Icon size={iconSize} type={iconType} name={icon} {...generateTestId('Icon')} />}
        {body}
      </CardBody>
    </CardContainer>
  );
};
